import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_324: DocMigration = {
  maxSchemaVersion: "0.0.324",
  description: "Add plan set template config to each plan set template",
  apply(json: any): any {
    if (!json.planSetTemplateConfigs) {
      json.planSetTemplateConfigs = {};
    }

    for (const planSetTemplateId in json.planSetTemplates) {
      const planSetTemplate = json.planSetTemplates[planSetTemplateId];

      const id = uid();

      json.planSetTemplateConfigs[id] = {
        id,
        name: "Default",
        parentId: planSetTemplate.id,
        sortIndex: 0,
        parameterValues: {},
      };
    }

    return json;
  },
};

export default migration_0_0_324;
